
import { defineComponent, onMounted, computed, ref, watch, PropType } from 'vue'
import type { CategoryMeals } from '@/apis/response.type'

export default defineComponent({
  name: 'Pagination',
  props: {
    getMeals: {
      required: false,
      type: Array as PropType<CategoryMeals[]>
    }
  },
  emits: ['changePage'],
  setup (prop, { emit }) {
    const hasPrev = ref(false)
    const hasNext = ref(true)
    const currentPage = ref(1)

    const pages = computed(() => {
      return prop.getMeals ? Math.ceil(prop.getMeals.length / 6) : 0
    })

    const getMeals = computed(() => prop.getMeals)

    function changePage (page: number) {
      currentPage.value = page
      emit('changePage', page)
    }

    function prevPage () {
      currentPage.value--
      changePage(currentPage.value)
    }

    function nextPage () {
      currentPage.value++
      changePage(currentPage.value)
    }

    watch(currentPage, val => {
      hasPrev.value = val > 1
      hasNext.value = val < pages.value && pages.value !== 1
    })

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    watch(getMeals, (_value, _oldValue) => {
      currentPage.value = 1
      hasNext.value = true

      if (pages.value === 1) {
        hasPrev.value = false
        hasNext.value = false
      }
    })

    onMounted(() => {
      hasNext.value = pages.value !== 1
      // Initial meal list, if no data then pagination disable
      if (getMeals.value && getMeals.value.length === 0) {
        hasPrev.value = false
        hasNext.value = false
      }
    })

    return {
      pages,
      hasPrev,
      hasNext,
      currentPage,
      changePage,
      prevPage,
      nextPage
    }
  }
})
